import { GetterTree, ActionTree, MutationTree } from "vuex/types"

import isEmptyObject from '~/helpers/is-empty-object'
import { isSitecoreIntegrated } from '~/utils/environment'

import { loginOnUnauthorized } from './plugins'
import { RootState } from './store.types'

// TODO - We need to update this when the user store is complete
export interface User {
  account: { data: { id: string } }
  membership: { data: {} }
}

export interface OAuthUser {
  accessToken: string
  refreshToken: string
}

export interface AppState {
  initializedApp: boolean
  oauth?: OAuthUser
  user?: User
}

export const plugins = [loginOnUnauthorized]

export const state = (): AppState => ({ initializedApp: false })

export const strict = false

export const getters: GetterTree<AppState, RootState> = {
  currentUser ({ oauth, user }) {
    if (oauth && user) {
      const { accessToken: token } = oauth
      const {
        account: { data: account },
        membership: { data: membership }
      } = user

      const nonMemberAccount = !membership || isEmptyObject(membership)

      if (token && !isEmptyObject(account)) {
        return { id: account.id, account, membership: { nonMemberAccount, ...membership }, token }
      }
    }

    return null
  }
}

export const actions: ActionTree<AppState, RootState> = {
  async nuxtClientInit ({ getters }) {
    const acceptedAnalytics = getters['user/account/analyticsConsent']
    const acceptedCookies = this.$cookies.get('cookie_consent')

    if (acceptedAnalytics || acceptedCookies) {
      this.$gtm.activate()
    }
  },

  async nuxtServerInit ({ dispatch, commit }, { query }) {
    await dispatch('ui/environment/setIsWebview', ('webview' in query))

    const isExperienceEditor = isSitecoreIntegrated(this.$env)
    if (isExperienceEditor) {
      dispatch('jss/enableIntegrationMode')
    } else {
      // do not need load header in EE mode, it will be added as a component
      await dispatch('ui/environment/fetchEnv')
    }
  }
}

export const mutations: MutationTree<AppState> = {
  initializeApp (state) {
    state.initializedApp = true
  }
}
